module.exports = __webpack_public_path__ + "static/busy-2351426527105ac309b4e9327ea7eb0b.png";